export default __webpack_public_path__ + "static/media/image.b6a9e459.png";